import { removeRecipientLink } from '../strings.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47750 */
import * as React from 'react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import { EmailAddressWrapper } from 'owa-recipient-cache';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import getRemoveRecipientButtonStyle from '../utils/getRemoveRecipientButtonStyle';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';

const styles = require('./MultiRecipientMailtip.scss');
const classNames = require('classnames');

export interface RemoveRecipientButtonProps {
    colorScheme?: ColorScheme;
    onClick: (recipient: EmailAddressWrapper) => void;
    recipient: EmailAddressWrapper;
}

const RemoveRecipientButton = (props: RemoveRecipientButtonProps): JSX.Element => {
    const { onClick, recipient, colorScheme } = props;
    return (
        <TooltipHost
            id="removeButtonID"
            content={loc(removeRecipientLink)}
            calloutProps={{ gapSpace: 0, ariaLabel: loc(removeRecipientLink) }}
            hostClassName={styles.closeButton}>
            <IconButton
                aria-describedby="removeButtonID"
                onClick={() => onClick(recipient)}
                className={classNames(
                    styles.recipientRowIcon,
                    getRemoveRecipientButtonStyle(colorScheme)
                )}
                iconProps={{
                    iconName: ControlIcons.Cancel,
                    styles: {
                        root: {
                            fontSize: '12px',
                            height: '12px',
                        },
                    },
                }}
                ariaLabel={loc(removeRecipientLink)}
            />
        </TooltipHost>
    );
};

export default RemoveRecipientButton;
